module.exports = __webpack_public_path__ + "static/media/esport.24a01785.svg";